import { Spin } from 'antd';
import classNames from 'classnames';
import { DateTime } from 'luxon';
import parse from 'html-react-parser';
import useQuery from '../../../../util/useQuery';

export default function PreviewArticle({ detail, loading, logo }) {
    const personalDataCollection = detail?.personalDataCollection;
    const disclosurePersonalData = detail?.disclosurePersonalData;
    // const personalDataTopic = detail?.disclosurePersonalData?.personalDataTopic;
    const dataSubjectRightAndSecure = detail?.dataSubjectRightAndSecure;
    const marketingAdvertising = detail?.marketingAdvertising;
    const privacyPolicy = detail?.privacyPolicy;
    const dataController = detail?.dataController;
    const dpo = detail?.dpo;

    const params = useQuery();

    return (
        <Spin spinning={loading}>
            <div
                className={classNames({
                    'rounded-md py-4 pl-4 pr-2 w-full border-1 max-w-4xl my-4 mx-auto bg-white':
                        !params.get('ember'),
                    'm-0 w-full !border-none ': params.get('ember') === '1',
                })}
                style={{ border: '1px solid #DBDBDB' }}
            >
                <div>
                    <div className="px-2">
                        <article className="prose max-w-full text-left">
                            <div className="text-center">
                                {personalDataCollection?.companyLogoId && (
                                    <img
                                        className="w-auto h-28 rounded-lg object-cover m-0"
                                        src={logo}
                                        alt={
                                            personalDataCollection?.companyNameTh
                                        }
                                    />
                                )}
                                <h3>
                                    ประกาศการคุ้มครองข้อมูลส่วนบุคคล{' '}
                                    {personalDataCollection?.companyNameTh}
                                </h3>
                                <p className="indent-8 text-left">
                                    {personalDataCollection?.companyNameTh}{' '}
                                    (“บริษัท”)
                                    ขอแนะนำให้ท่านทำความเข้าใจประกาศการคุ้มครองข้อมูลส่วนบุคคล
                                    (privacy notice) นี้ เนื่องจาก
                                    ประกาศนี้อธิบายถึงวิธีการที่บริษัทปฏิบัติต่อข้อมูลส่วนบุคคลของท่าน
                                    เช่น การเก็บรวบรวม การจัดเก็บรักษา การใช้
                                    การเปิดเผย รวมถึงสิทธิต่างๆ ของท่าน
                                    ในฐานะที่เป็นเจ้าของข้อมูลส่วนบุคคล
                                    โดยอ้างอิงตาม
                                    นโยบายคุ้มครองข้อมูลส่วนบุคคลของ
                                    {personalDataCollection?.companyNameTh}{' '}
                                    เป็นต้น
                                    เพื่อให้ท่านได้รับทราบถึงมาตรการในการคุ้มครองข้อมูลส่วนบุคคลของบริษัท
                                    บริษัทจึงประกาศการคุ้มครองข้อมูลส่วนบุคคล
                                    ดังต่อไปนี้
                                </p>
                            </div>

                            {(disclosurePersonalData?.personalDataOptionSequence
                                ?.length !== 0 ||
                                disclosurePersonalData
                                    ?.sensitivePersonalDataOptionSequence
                                    ?.length !== 0) && (
                                <>
                                    <h4>ข้อมูลส่วนบุคคล</h4>
                                    <p className="indent-8">
                                        “ข้อมูลส่วนบุคคล” หมายถึง
                                        ข้อมูลที่สามารถระบุตัวตนของท่าน
                                        หรืออาจจะระบุตัวตนของท่านได้
                                        ไม่ว่าทางตรงหรือทางอ้อม
                                    </p>
                                    <h4>การเก็บรวบรวมข้อมูลส่วนบุคคล</h4>
                                    <p className="indent-8">
                                        ข้อมูลส่วนบุคคลของท่านที่บริษัทเก็บรวบรวม
                                        ใช้ และ/หรือเปิดเผย มีดังนี้
                                    </p>
                                    <table
                                        border={0}
                                        style={{
                                            width: '100%',
                                            borderCollapse: 'collapse',
                                            borderStyle: 'hidden',
                                            borderColor: '#f9f9f9',
                                            backgroundColor: '#f9f9f9',
                                            marginBottom: '5px',
                                            textAlign: 'left',
                                            padding: '1rem',
                                            borderRadius: 6,
                                        }}
                                    >
                                        <thead>
                                            <tr>
                                                <th
                                                    style={{
                                                        padding: '1rem',
                                                    }}
                                                >
                                                    ประเภทข้อมูล
                                                </th>
                                                <th
                                                    style={{
                                                        padding: '1rem',
                                                    }}
                                                >
                                                    รายละเอียดข้อมูล
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {disclosurePersonalData
                                                ?.personalDataOptionSequence
                                                ?.length !== 0 && (
                                                <tr
                                                    style={{
                                                        borderTop:
                                                            '1px solid #e9e9e9',
                                                    }}
                                                >
                                                    <td
                                                        style={{
                                                            width: '40%',
                                                            paddingLeft: '1rem',
                                                        }}
                                                    >
                                                        ข้อมูลส่วนบุคคล
                                                    </td>
                                                    <td>
                                                        <ul
                                                            style={{
                                                                paddingLeft:
                                                                    '0px',
                                                            }}
                                                        >
                                                            {disclosurePersonalData?.personalDataOptionSequence?.map(
                                                                (option, i) => (
                                                                    <li key={i}>
                                                                        {
                                                                            option.personDataOptionNameTh
                                                                        }
                                                                    </li>
                                                                )
                                                            )}
                                                        </ul>
                                                    </td>
                                                </tr>
                                            )}
                                            {disclosurePersonalData
                                                ?.sensitivePersonalDataOptionSequence
                                                ?.length !== 0 && (
                                                <tr
                                                    style={{
                                                        borderTop:
                                                            '1px solid #e9e9e9',
                                                    }}
                                                >
                                                    <td
                                                        style={{
                                                            width: '40%',
                                                            paddingLeft: '1rem',
                                                        }}
                                                    >
                                                        ข้อมูลส่วนบุคคลอ่อนไหว
                                                    </td>
                                                    <td>
                                                        <ul
                                                            style={{
                                                                paddingLeft:
                                                                    '0px',
                                                            }}
                                                        >
                                                            {disclosurePersonalData?.sensitivePersonalDataOptionSequence?.map(
                                                                (option, i) => (
                                                                    <li key={i}>
                                                                        {
                                                                            option.sensitivePersonDataOptionNameTh
                                                                        }
                                                                    </li>
                                                                )
                                                            )}
                                                        </ul>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </>
                            )}
                            <h4>แหล่งที่มาของข้อมูลส่วนบุคคล</h4>
                            <p className="indent-8">
                                บริษัทอาจได้รับข้อมูลส่วนบุคคลของท่านจากช่องทางดังนี้
                            </p>
                            {personalDataCollection?.dataSourceFromDs && (
                                <>
                                    <h4>การเก็บข้อมูลโดยตรงจากท่าน</h4>
                                    {parse(
                                        `${
                                            personalDataCollection?.dataSourceFromDsTh ||
                                            '-'
                                        }`
                                    )}
                                </>
                            )}

                            {personalDataCollection?.dataSourceFromOther && (
                                <>
                                    <h4>การเก็บข้อมูลจากแหล่งอื่น</h4>

                                    {parse(
                                        `${
                                            personalDataCollection?.dataSourceFromOtherTh ||
                                            '-'
                                        }`
                                    )}
                                </>
                            )}

                            <h4>วัตถุประสงค์การเก็บ รวบรวม ใช้และเปิดเผย</h4>

                            {parse(
                                `${
                                    personalDataCollection?.purposeOfDataCollectionTh ||
                                    '-'
                                }`
                            )}

                            <h4>การเปิดเผยข้อมูลส่วนบุคคลให้บุคคลอื่น </h4>
                            <p className="indent-8 whitespace-pre-wrap">
                                บริษัทจะไม่เปิดเผยข้อมูลส่วนบุคคลของท่านกับบุคคลและนิติบุคคลอื่นที่ไม่ได้เป็นบริษัทในกลุ่มของบริษัท
                                (“บุคคลอื่น”)
                                เว้นแต่เป็นการเปิดเผยเพื่อบรรลุวัตถุประสงค์การเก็บรวบรวมและประมวลผลข้อมูลส่วนบุคคลตามที่ระบุไว้ในประกาศความเป็นส่วนตัวนี้
                                โดยบริษัทอาจเปิดเผยข้อมูลส่วนบุคคลของท่านให้บุคคลอื่น
                                เช่น{' '}
                            </p>

                            {parse(
                                `${
                                    disclosurePersonalData?.discloseToOtherPersonTh ||
                                    '-'
                                }`
                            )}

                            <h4>ระยะเวลาในการเก็บรักษาข้อมูลส่วนบุคคล </h4>

                            {parse(
                                `${
                                    disclosurePersonalData?.retentionPeriodTh ||
                                    '-'
                                }`
                            )}

                            <h4>
                                การส่งหรือโอนข้อมูลส่วนบุคคลของท่านไปต่างประเทศ
                            </h4>

                            {parse(
                                `${
                                    disclosurePersonalData?.transferPersonalDataTh ||
                                    '-'
                                }`
                            )}

                            <h4>สิทธิของท่านเกี่ยวกับข้อมูลส่วนบุคคล </h4>
                            <p className="indent-8 whitespace-pre-wrap">
                                ท่านสามารถขอใช้สิทธิของท่านภายใต้ข้อกำหนดของกฎหมาย
                                และนโยบายที่กำหนดไว้ในขณะนี้หรือที่จะมีการแก้ไขเพิ่มเติมในอนาคต
                                ตลอดจนหลักเกณฑ์ตามที่บริษัทกำหนด
                            </p>
                            <ul>
                                <li>
                                    <h4>สิทธิขอเพิกถอนความยินยอม</h4>
                                    {parse(
                                        `${
                                            dataSubjectRightAndSecure?.rightToWithdrawConsentTh ||
                                            '-'
                                        }`
                                    )}
                                </li>
                                <li>
                                    <h4>สิทธิขอเข้าถึงข้อมูลและขอรับสำเนา</h4>

                                    {parse(
                                        `${
                                            dataSubjectRightAndSecure?.rightOfAccessTh ||
                                            '-'
                                        }`
                                    )}
                                </li>
                                <li>
                                    <h4>สิทธิขอถ่ายโอนข้อมูล</h4>

                                    {parse(
                                        `${
                                            dataSubjectRightAndSecure?.rightOfDataPortabilityTh ||
                                            '-'
                                        }`
                                    )}
                                </li>
                                <li>
                                    <h4>สิทธิขอคัดค้าน</h4>

                                    {parse(
                                        `${
                                            dataSubjectRightAndSecure?.rightToObjectTh ||
                                            '-'
                                        }`
                                    )}
                                </li>
                                <li>
                                    <h4>สิทธิขอระงับการใช้ข้อมูล</h4>

                                    {parse(
                                        `${
                                            dataSubjectRightAndSecure?.rightToRestrictProcessingTh ||
                                            '-'
                                        }`
                                    )}
                                </li>
                                <li>
                                    <h4>สิทธิขอให้ลบหรือทำลายข้อมูล</h4>

                                    {parse(
                                        `${
                                            dataSubjectRightAndSecure?.rightToErasureTh ||
                                            '-'
                                        }`
                                    )}
                                </li>
                                <li>
                                    <h4>สิทธิขอให้แก้ไขข้อมูล</h4>
                                    {parse(
                                        `${
                                            dataSubjectRightAndSecure?.rightToRectificationTh ||
                                            '-'
                                        }`
                                    )}
                                </li>
                                {dataSubjectRightAndSecure?.rightToComplaintTh && (
                                    <li>
                                        <h4>สิทธิขอร้องเรียนข้อมูล</h4>
                                        {parse(
                                            `${
                                                dataSubjectRightAndSecure?.rightToComplaintTh ||
                                                '-'
                                            }`
                                        )}
                                    </li>
                                )}
                            </ul>
                            <h4>
                                มาตรการรักษาความมั่นคงปลอดภัยและคุณภาพของข้อมูล
                            </h4>

                            {parse(
                                `${
                                    dataSubjectRightAndSecure?.securityMeasureTh ||
                                    '-'
                                }`
                            )}

                            <h4>กิจกรรมทางการตลาดและการส่งเสริมการตลาด</h4>

                            {parse(
                                `${
                                    marketingAdvertising?.marketingActivityTh ||
                                    '-'
                                }`
                            )}

                            <h4>
                                นโยบายคุ้มครองข้อมูลส่วนบุคคลของเว็บไซต์อื่น
                            </h4>

                            {parse(`${privacyPolicy?.policyWebsiteTh || '-'}`)}

                            <h4>
                                ในกรณีที่ท่านปฏิเสธไม่เปิดเผยหรือให้ใช้ข้อมูลส่วนบุคคล
                            </h4>

                            {parse(
                                `${privacyPolicy?.undisclosedReasonTh || '-'}`
                            )}

                            <h4>
                                การดำเนินการ แนวปฏิบัติ
                                และนโยบายที่เกี่ยวกับข้อมูลส่วนบุคคล
                            </h4>

                            {parse(`${privacyPolicy?.processPolicyTh || '-'}`)}

                            <h4>เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล</h4>

                            {parse(`${dpo?.dpoNameTh || '-'}`)}

                            <h4>ช่องทางการติดต่อบริษัท</h4>

                            {parse(
                                `${dataController?.contactChannelTh || '-'}`
                            )}

                            <h4>
                                ฉบับ ณ วันที่{' '}
                                {personalDataCollection?.effectiveDate
                                    ? DateTime.fromISO(
                                          personalDataCollection?.effectiveDate,
                                          { locale: 'th' }
                                      ).toLocaleString(DateTime.DATE_FULL)
                                    : '-'}
                            </h4>
                        </article>
                    </div>
                </div>
            </div>
        </Spin>
    );
}
